import React from "react";
import { STEPS } from "../mock";
import Reveal from "./Reveal";

export default function HowItWorks() {
  return (
    <section
      id="proceso"
      className="py-20 md:py-28 bg-[#f5f1e8] border-t border-[#e8ddc3]/60"
    >
      <div className="max-w-6xl mx-auto px-6">
        <Reveal className="text-center mb-14 md:mb-20">
          <div className="text-[11px] md:text-xs tracking-[0.25em] uppercase text-[#b59557] mb-4">
            Proceso
          </div>
          <h2 className="font-serif font-medium text-[#1a1816] text-3xl md:text-5xl leading-tight">
            ¿Cómo{" "}
            <span className="italic text-[#b59557] font-light">funciona</span>?
          </h2>
        </Reveal>

        <div className="relative">
          {/* Subtle connecting line */}
          <div className="hidden md:block absolute left-[10%] right-[10%] top-9 h-px bg-gradient-to-r from-transparent via-[#d6cdb9] to-transparent" />

          <div className="grid grid-cols-1 md:grid-cols-4 gap-6 md:gap-6">
            {STEPS.map((st, i) => (
              <Reveal key={st.num} delay={(i % 3) + 1} className="flex md:block items-start gap-4 text-left md:text-center">
                <div className="relative inline-block shrink-0">
                  <div className="h-12 w-12 md:h-[72px] md:w-[72px] rounded-full bg-[#f5f1e8] border border-[#d6cdb9] flex items-center justify-center md:mx-auto">
                    <span className="font-serif italic text-xl md:text-3xl text-[#b59557]">
                      {st.num}
                    </span>
                  </div>
                </div>
                <div className="flex-1 md:mt-0">
                  <h3 className="md:mt-6 font-serif text-base md:text-xl text-[#1a1816]">
                    {st.title}
                  </h3>
                  <p className="mt-1.5 md:mt-3 text-sm text-[#4a4136]/85 leading-relaxed md:max-w-[220px] md:mx-auto">
                    {st.description}
                  </p>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
